import React from 'react';
import NhiemVuTTXM from './NhiemVuTTXM.jsx';
import {TextMessage} from 'components/tt-forms/common';
import { connect } from 'react-redux';
import {Link, browserHistory} from 'react-router';
import {ContainerFileDinhKem} from 'components/upload';

class KetQuaNhapThongTinToTTXM extends React.Component {

  onClickClose() {
    if (typeof this.props.handleBack == 'function') {
      this.props.handleBack();
    } else {
      browserHistory.goBack();
    }
  }

  render() {
    let lb2 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? ' đề xuất' : '';
    return (
      <section className="wrap-block">
        <NhiemVuTTXM
        donViGiaoThamTraXacMinh={this.props.donViGiaoThamTraXacMinhInfo}
        ngayBatDauTTXM={this.props.ngayBatDauTTXM}
        donInfo = {this.props.donInfo}
        yKienCuaDonViGiaoTTXM = {this.props.yKienCuaDonViGiaoTTXM}
        ngayHetHanTTXM={this.props.ngayHetHanTTXM}/>
        <div className="wrap-big-line pt5 pb20">
          <span className="big-border"></span>
        </div>
        <div className="row pl10 pr10">
          <div className="col-100">
            <div className="col-100 no-gutter">
              <h2 className="title-14 mb15">Báo cáo kết quả xác minh{lb2}</h2>
              <div className="col-100 no-gutter">
                <TextMessage className="col-100 no-gutter" label="Ý kiến xử lý:" value={this.props.noiDungTraBaoCaoTTXMLan2 ? this.props.noiDungTraBaoCaoTTXMLan2 : this.props.noiDungTraBaoCaoTTXMLan1}/>
              </div>
            </div>
          </div>
          <div className="col-100 pb5">
            <ContainerFileDinhKem label="Danh sách văn bản xử lý" hideDescription={true} bindValidator={this} dataShow={this.props.listTaiLieuVanThuGiaiQuyetDon} disableAttachFile={true}/>
          </div>
          <div className="box-bottom col-100">
            <div className="wrap-big-line mt10 mb20"><div className="line-border"></div></div>
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
          </div>
        </div>
      </section>
    );
  }
}

KetQuaNhapThongTinToTTXM.defaultProps = {
  dataKetLuanNoiDungKhieuNai: []
}

let bindStateToProps = state => {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai
  }
}

export default connect(bindStateToProps)(KetQuaNhapThongTinToTTXM);


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/KetQuaNhapThongTinToTTXM.jsx